import { defineMessages } from '@transcend-io/internationalization';

export const heroMessages = defineMessages(
  'privacy-center.components.Hero.hero',
  {
    aboutTranscend: {
      defaultMessage: 'Show me how the {privacyCenter} works →',
      description: 'Link to about Transcend page in the hero.',
    },
    assetAlt: {
      defaultMessage: 'Hero image',
    },
  },
);
